import { Button, cn } from "@heroui/react";
import { SkipForward } from "react-bootstrap-icons";

interface OptionActionsProps {
  isMultiSelect: boolean;
  isSkippable: boolean;
  isRevealed: boolean;
  selectedOptions: string[];
  onConfirmMultiSelect: () => void;
  onSkipQuestion: () => void;
}

export const OptionActions: React.FC<OptionActionsProps> = ({
  isMultiSelect,
  isSkippable,
  isRevealed,
  selectedOptions,
  onConfirmMultiSelect,
  onSkipQuestion,
}) => {
  if (!isMultiSelect && !isSkippable) {
    return null;
  }

  return (
    <div
      className={cn(
        "mt-4",
        "flex",
        "flex-col",
        "sm:flex-row",
        "gap-2",
        "sm:justify-end",
        "transition-all duration-300 ease-out",
        isRevealed ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4",
      )}
      style={{
        transitionDelay: "600ms",
      }}
    >
      {isSkippable && (
        <Button
          className={cn(
            "w-full",
            "sm:w-auto",
            "transition-all duration-300 ease-out hover:scale-105",
            "bg-slate-700/60 hover:bg-slate-600/70",
            "border border-gray-600/50 hover:border-gray-500",
            "text-gray-300 hover:text-white",
            "backdrop-blur-sm",
            "hover:shadow-lg hover:shadow-gray-500/20",
          )}
          startContent={<SkipForward className="w-4 h-4" />}
          variant="ghost"
          onPress={onSkipQuestion}
        >
          Skip this question
        </Button>
      )}
      {isMultiSelect && (
        <Button
          className={cn(
            "w-full",
            "sm:w-auto",
            "transition-all duration-300 ease-out hover:scale-105",
            "bg-gradient-to-r from-indigo-500 to-indigo-600",
            "hover:from-indigo-600 hover:to-indigo-700",
            "text-white font-semibold",
            "border-0",
            "shadow-xl hover:shadow-blue-500/30",
            "backdrop-blur-sm",
            selectedOptions.length === 0 && "opacity-50 cursor-not-allowed",
          )}
          color="primary"
          isDisabled={selectedOptions.length === 0}
          variant="solid"
          onPress={onConfirmMultiSelect}
        >
          Confirm selection
        </Button>
      )}
    </div>
  );
};
